import { Helmet } from "react-helmet";
import React from "react";
import { useState, useEffect } from "react";
import sendRequest from "hooks/useAxios";
import "components/blog/blog.css";
import Blogknowable from "components/blog/BlogKnowable";
import BlogVideo from "components/blog/BlogVideo";
import GroupView from "common/Group-View/GroupViewItem";
import Blog from "common/blog/Blog";
import { pageSectionId } from "constants/constants";

export default function Blog1() {
  const [blognews, setBlognews] = useState([
    {
      title: "داغ ترین تکنولوژی",
      item: [
        { title: "قوی ترین لپ تاپ مهندسی جهان", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "کارت های اعتباری مجهز به حسگر اثر انگشت", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "آموزش نصب ویندوز 11", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "قوی ترین لپ تاپ مهندسی جهان", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
      ],
    },
    {
      title: "آخرین مطالب",
      item: [
        { title: "قوی ترین لپ تاپ مهندسی جهان", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "کارت های اعتباری مجهز به حسگر اثر انگشت", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "آموزش نصب ویندوز 11", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "قوی ترین لپ تاپ مهندسی جهان", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
      ],
    },
    {
      title: "اخبار",
      item: [
        { title: "قوی ترین لپ تاپ مهندسی جهان", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "کارت های اعتباری مجهز به حسگر اثر انگشت", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "آموزش نصب ویندوز 11", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
        { title: "قوی ترین لپ تاپ مهندسی جهان", description: "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.", date: "1401/1/1", writer: "امین تقوی نیا", link: "" },
      ],
    },
  ]);
  const [blogHashtags, setBlogHashtags] = useState([]);
  const [postList, setPostList] = useState([]);
  useEffect(() => {
    sendRequest("gethashtag", { hashtagType: 1 }).then(({ data }) => {
      setBlogHashtags(data.hashtags);
    });
    sendRequest("getlistofpost").then(({ data }) => {
      setPostList(data.postList);
    });
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>بلاگ</title>
      </Helmet>
      <BlogVideo postList={postList}></BlogVideo>
      {blognews.map((value, index) => {
        return <GroupView Component={Blog} numberOf={value.item.length} id={index} items={value.item} idConfig={Object.values(pageSectionId)[index + 2]} title={value.title} type={1} moreText="مطالب بیشتر"></GroupView>;
      })}
      <Blogknowable blogHashtags={blogHashtags}></Blogknowable>
    </div>
  );
}
